<template>
    <OpenableMenu
        class="display-options-menu"
    >
        <template v-slot:label>
            Weergaveopties
        </template>
        <template v-slot:content>
            <List class="submenu-list">
                <ListItem @click.stop>
                    <CqSelectInput label="Medewerkers sorteren op:" :options="employeeSortingOptions" v-model="employeeSorting" noMargin />
                </ListItem>
                <ListItem @click.stop>
                    <CqToggle label="Toon alle" v-model="showAllWorkSchedules" />
                </ListItem>
                <ListItem @click.stop v-if="hasFilterablePositionTypes">
                    <CqSelectInput
                        label="Toon werkindelingen"
                        :options="showReachableOptions"
                        v-model="showReachable"
                        noMargin
                    />
                </ListItem>
            </List>
        </template>
    </OpenableMenu>
</template>

<script lang="ts">
    import {Component, Vue, Prop, Model} from 'vue-facing-decorator';
    import {CqSelectInput, CqToggle, StringSelectInputOption, NumberSelectInputOption} from '@cquential/ui';
    import {WorkSchedulePreference} from '@/types/types';
    import OpenableMenu from '@/components/Branding/OpenableMenu.vue';
    import List from '@/components/Branding/List.vue';
    import ListItem from '@/components/Branding/ListItem.vue';
    import {WorkSchedulePositionTypeFilterOptions} from '@/types/enums/WorkSchedulePositionTypeFilterOptions';

    @Component({
        components: {
            CqSelectInput,
            CqToggle,
            OpenableMenu,
            List,
            ListItem,
        },
        emits: ['input:preference'],
    })
    export default class DisplayOptionsMenu extends Vue {
        @Prop({type: Boolean}) public hasFilterablePositionTypes!: boolean;
        @Model({required: true}) public workSchedulePreference!: WorkSchedulePreference;

        public get showAllWorkSchedules(): boolean {
            return this.workSchedulePreference.showAllWorkSchedules;
        }

        public set showAllWorkSchedules(val: boolean) {
            this.workSchedulePreference = {
                ...this.workSchedulePreference,
                showAllWorkSchedules: val,
            };
        }

        public get showReachable(): number {
            return this.workSchedulePreference.viewReachable ? WorkSchedulePositionTypeFilterOptions.Reachable : WorkSchedulePositionTypeFilterOptions.Working;
        }

        public set showReachable(val: number) {
            this.workSchedulePreference = {
                ...this.workSchedulePreference,
                viewReachable: val === WorkSchedulePositionTypeFilterOptions.Reachable,
            };
        }

        public get employeeSorting(): WorkSchedulePreference['employeeSorting'] {
            return this.workSchedulePreference.employeeSorting;
        }

        public set employeeSorting(val: WorkSchedulePreference['employeeSorting']) {
            this.workSchedulePreference = {
                ...this.workSchedulePreference,
                employeeSorting: val,
            };
        }

        public employeeSortingOptions: StringSelectInputOption[] = [
            {
                value: 'rosterRank',
                label: 'Medewerkervolgorde dienstlijst',
            },
            {
                value: 'beginTime',
                label: 'Begintijd dienst',
            },
        ];

        public get showReachableOptions(): NumberSelectInputOption[] {
            return [
                {
                    value: WorkSchedulePositionTypeFilterOptions.Working,
                    label: 'Paraat',
                },
                {
                    value: WorkSchedulePositionTypeFilterOptions.Reachable,
                    label: 'Bereikbaar',
                },
            ];
        }
    }
</script>

<style lang="scss" scoped>
    .submenu-list {
        min-width: 15rem;
        max-width: 15rem;
    }
</style>
